export default "__VITE_ASSET__D3Gezn$i__ 720w";